"use client";

import { useEffect } from "react";
import AppErrorView from "@/app/components/AppErrorView";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Critical root application error:", error);
  }, [error]);

  return <AppErrorView statusCode={500} isGlobal error={error} reset={reset} />;
}
